import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export interface EmailErrors {
  email?: true;
  invalidTestDomain?: true;
  trailingDot?: true;
}

export const businessEmailValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = (control.value ?? '').toString().trim();

  if (!value) {
    return null;
  }

  if (Validators.email(control)) {
    return { email: true };
  }

  if (value.endsWith('.')) {
    return { trailingDot: true };
  }

  if (value.toLowerCase().endsWith('.test')) {
    return { invalidTestDomain: true };
  }

  return null;
};